import * as React from "react";

import primaryColour from "../../constants";

function SvgCameraevent(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.43353 7.79175H15.0983C15.8844 7.79175 16.5318 8.43915 16.5318 9.22527V10.8438L19.3988 8.90157C19.6301 8.76285 20 8.90157 20 9.22527V15.6068C20 15.9767 19.6301 16.1154 19.3988 15.9305L16.5318 13.9883V15.653C16.5318 16.4391 15.8844 17.0865 15.0983 17.0865H5.43353C4.6474 17.0865 4 16.4391 4 15.653V9.22527C4 8.43915 4.6474 7.79175 5.43353 7.79175ZM11.6763 11.9998L9.4104 10.6588C9.04046 10.4738 8.62428 10.705 8.62428 11.1212V13.7571C8.62428 14.127 9.04046 14.4045 9.4104 14.2195L11.6763 12.8785C12 12.6935 12 12.1848 11.6763 11.9998Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgCameraevent;
